// extracted by mini-css-extract-plugin
export var container = "Dates-module--container--1bf61";
export var containerInline = "Dates-module--container-inline--500f4";
export var duration = "Dates-module--duration--b740b";